export const states = [
  // {
  //   info: "Punjab",
  //   value: "Punjab"
  // },
  {
    info: "Alabama",
    value: "Alabama"
  },
  {
    info: "Alaska",
    value: "Alaska"
  },
  {
    info: "Arizona",
    value: "Arizona"
  },
  {
    info: "Arkansas",
    value: "Arkansas"
  },
  {
    info: "California",
    value: "California"
  },
  {
    info: "Colorado",
    value: "Colorado"
  },
  {
    info: "Connecticut",
    value: "Connecticut"
  },
  {
    info: "Delaware",
    value: "Delaware"
  },
  {
    info: "District Of Columbia",
    value: "District Of Columbia"
  },
  {
    info: "Florida",
    value: "Florida"
  },
  {
    info: "Georgia",
    value: "Georgia"
  },
  {
    info: "Hawaii",
    value: "Hawaii"
  },
  {
    info: "Idaho",
    value: "Idaho"
  },
  {
    info: "Illinois",
    value: "Illinois"
  },
  {
    info: "Indiana",
    value: "Indiana"
  },
  {
    info: "Iowa",
    value: "Iowa"
  },
  {
    info: "Kansas",
    value: "Kansas"
  },
  {
    info: "Kentucky",
    value: "Kentucky"
  },
  {
    info: "Louisiana",
    value: "Louisiana"
  },
  {
    info: "Maine",
    value: "Maine"
  },
  {
    info: "Maryland",
    value: "Maryland"
  },
  {
    info: "Massachusetts",
    value: "Massachusetts"
  },
  {
    info: "Michigan",
    value: "Michigan"
  },
  {
    info: "Minnesota",
    value: "Minnesota"
  },
  {
    info: "Mississippi",
    value: "Mississippi"
  },
  {
    info: "Missouri",
    value: "Missouri"
  },
  {
    info: "Montana",
    value: "Montana"
  },
  {
    info: "Nebraska",
    value: "Nebraska"
  },
  {
    info: "Nevada",
    value: "Nevada"
  },
  {
    info: "New Hampshire",
    value: "New Hampshire"
  },
  {
    info: "New Jersey",
    value: "New Jersey"
  },
  {
    info: "New Mexico",
    value: "New Mexico"
  },
  {
    info: "New York",
    value: "New York"
  },
  {
    info: "North Carolina",
    value: "North Carolina"
  },
  {
    info: "North Dakota",
    value: "North Dakota"
  },
  {
    info: "Ohio",
    value: "Ohio"
  },
  {
    info: "Oklahoma",
    value: "Oklahoma"
  },
  {
    info: "Oregon",
    value: "Oregon"
  },
  {
    info: "Pennsylvania",
    value: "Pennsylvania"
  },
  {
    info: "Rhode Island",
    value: "Rhode Island"
  },
  {
    info: "South Carolina",
    value: "South Carolina"
  },
  {
    info: "South Dakota",
    value: "South Dakota"
  },
  {
    info: "Tennessee",
    value: "Tennessee"
  },
  {
    info: "Texas",
    value: "Texas"
  },
  {
    info: "Utah",
    value: "Utah"
  },
  {
    info: "Vermont",
    value: "Vermont"
  },
  {
    info: "Virginia",
    value: "Virginia"
  },
  {
    info: "Washington",
    value: "Washington"
  },
  {
    info: "West Virginia",
    value: "West Virginia"
  },
  {
    info: "Wisconsin",
    value: "Wisconsin"
  },
  {
    info: "Wyoming",
    value: "Wyoming"
  }
];

function createConverter(factor) {
  return (number, operation) => {
    if (operation === true)
      return parseFloat((number * factor).toFixed(2));
    if (operation === false)
      return parseFloat((number / factor).toFixed(2));

    return null;
  }
}

export const feetToMeter = createConverter(0.3048);
export const feet2ToMeter2 = createConverter(0.092903);